/**
 * Dashboard API Service
 *
 * Handles HTTP requests to the admin dashboard endpoints.
 * Backend endpoints created in SESSION_064.
 */

import { apiClient } from './ApiClient';
import type {
  AdminDashboardDto,
  RateLimitSection
} from '../../domain/entities/AdminDashboard';

/**
 * API service for admin dashboard data
 */
export class DashboardApi {
  /**
   * Get complete dashboard statistics
   * Endpoint: GET /api/admin/dashboard
   *
   * Returns crawler status, review queue metrics, rate limit data, and recent mentions
   */
  async getDashboardStats(): Promise<AdminDashboardDto> {
    return apiClient.get<AdminDashboardDto>('/api/admin/dashboard');
  }

  /**
   * Get rate limit status only
   * Endpoint: GET /api/admin/rate-limit
   *
   * Returns current Reddit API rate limit status or null if no data yet
   */
  async getRateLimit(): Promise<RateLimitSection | null> {
    try {
      return await apiClient.get<RateLimitSection>('/api/admin/rate-limit');
    } catch (error) {
      // 204 No Content is expected when rate limit data doesn't exist yet
      // This is normal behavior until first Reddit API call is made
      return null;
    }
  }
}

// Export singleton instance
export const dashboardApi = new DashboardApi();
